import { Link, useLocation } from 'react-router-dom';

export default function TopNavigation() {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity">
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg">
              <i className="ri-heart-pulse-line text-2xl text-white"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">HealthScore</span>
          </Link>

          {/* Navigation Links */}
          <div className="flex items-center gap-2">
            <Link 
              to="/"
              className={`px-4 py-2 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/') ? 'text-teal-600' : 'text-gray-600 hover:text-teal-700'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/dashboard"
              className={`px-4 py-2 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/dashboard') ? 'text-teal-600' : 'text-gray-600 hover:text-teal-700'
              }`}
            >
              Dashboard
            </Link>
            <Link 
              to="/score-explained"
              className={`px-4 py-2 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/score-explained') ? 'text-teal-600' : 'text-gray-600 hover:text-teal-700'
              }`}
            >
              About Scoring
            </Link>
            <Link 
              to="/contact"
              className={`px-4 py-2 font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/contact') ? 'text-teal-600' : 'text-gray-600 hover:text-teal-700'
              }`}
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
